import { FullStory, init } from '@fullstory/browser';

/** FullStory org id (same as FullStory dashboard / snippet). */
const FULLSTORY_ORG_ID = 'o-24K4DD-na1';

let fullstoryInitAttempted = false;

/** Call once at app startup (loads FullStory via npm SDK). */
export function initFullStoryIfConfigured(): void {
  if (fullstoryInitAttempted) return;
  fullstoryInitAttempted = true;
  init({
    orgId: FULLSTORY_ORG_ID,
  });
}

/** Correlate API failures with server logs via error_id (same UUID in response body). */
export function trackApiErrorEvent(payload: {
  error_id?: string;
  code?: string;
  message?: string;
  path?: string;
}): void {
  try {
    FullStory('trackEvent', {
      name: 'api_error',
      properties: {
        error_id_str: payload.error_id ?? '',
        error_code: payload.code ?? '',
        message: (payload.message ?? '').slice(0, 500),
        path: payload.path ?? '',
      },
    });
  } catch {
    // ignore FullStory failures
  }
}
